import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

/**
 * Return a Dayjs for the end of the last full month.
 */
export function endOfLastMonth(): Dayjs {
	return dayjs().subtract(1, 'month').endOf('month')
}
